/* eslint-disable max-len */
import React, { FC } from "react";

interface IProps {
  width?: number;
  height?: number;
}

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 22.0864H18C18.5304 22.0864 19.0391 21.8757 19.4142 21.5006C19.7893 21.1256 20 20.6169 20 20.0864V7.08643L15 2.08643H6C5.46957 2.08643 4.96086 2.29714 4.58579 2.67221C4.21071 3.04728 4 3.55599 4 4.08643V7.08643M14 2.08643V6.08643C14 6.61686 14.2107 7.12557 14.5858 7.50064C14.9609 7.87571 15.4696 8.08643 16 8.08643H20M9.5 17.5864L8 16.3364V14.0864M14 16.0864C14 19.4001 11.3137 22.0864 8 22.0864C4.68629 22.0864 2 19.4001 2 16.0864C2 12.7727 4.68629 10.0864 8 10.0864C11.3137 10.0864 14 12.7727 14 16.0864Z"
      stroke="#262626"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
